import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.FX = {
      texts: [],
    };
    gsap.delayedCall(0.1, () => {
      this.buildTexts();
      this._fx();
    });
  }

  buildTexts() {
    for (let text of this.ref.text) {
      const instanceLines = new SplitText(text.querySelector(".caption"), {
        type: "words",
        linesClass: "lines-css",
      });
      const instance = new SplitText(text.querySelector(".caption"), {
        type: "chars",
      });

      const fx = [];
      fx.push(text.querySelector(".line"));
      fx.push(text.querySelector(".number"));
      fx.push(instance.chars);
      this.FX.texts.push(fx);
    }
  }

  _fx() {
    this.animate();

    this.listener();
  }

  animate() {
    this.animation = gsap.timeline();

    for (let [i, fx] of this.FX.texts.entries()) {
      const timing = i == 0 ? "" : "<+=.1";
      this.animation.add(
        [
          gsap.fromTo(
            fx[0],
            {
              scaleX: 0,
              transformOrigin: "left top",
            },
            {
              scaleX: 1,
              ease: "quint.inOut",
              duration: 0.7,
            }
          ),
          gsap.fromTo(
            fx[1],
            {
              autoAlpha: 0,
              y: 5,
            },
            {
              autoAlpha: 1,
              duration: 0.5,
              y: 0,
              ease: "cubic.out",
            }
          ),
          gsap.fromTo(
            fx[2],
            {
              autoAlpha: 0,
              y: 7,
            },
            {
              autoAlpha: 1,
              duration: 1,
              y: 0,
              ease: "cubic.out",
              stagger: 0.02,
              delay: 0.2,
            }
          ),
        ],
        timing
      );
    }
  }

  listener() {
    this.stListener = ScrollTrigger.create({
      animation: this.animation,
      trigger: this.DOM.view,
      start: "top 80%",
    });
  }

  unmount() {
    this.stListener.kill();
  }
}
